import { render, staticRenderFns } from "./CreateLeave.vue?vue&type=template&id=32fb1160"
import script from "./CreateLeave.vue?vue&type=script&lang=js"
export * from "./CreateLeave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports